import { render, staticRenderFns } from "./error-display.vue?vue&type=template&id=c268cd3a&scoped=true&"
import script from "./error-display.vue?vue&type=script&lang=js&"
export * from "./error-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c268cd3a",
  null
  
)

export default component.exports